import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('AVAILABILITY', {
  OPEN_AVAILABILITY_DETAILS: null,
  CLOSE_AVAILABILITY_DETAILS: null,

  AVAILABILITY_DETAIL_REQUEST: null,
  AVAILABILITY_DETAIL_SUCCESS: null,
  AVAILABILITY_DETAIL_ERROR: null,

  DIGITAL_AVAILABILITY_REQUEST: null,
  DIGITAL_AVAILABILITY_SUCCESS: null,
  DIGITAL_AVAILABILITY_ERROR: null,

  HOLDINGS_PROBE_REQUEST: null,
  HOLDINGS_PROBE_SUCCESS: null,
  HOLDINGS_PROBE_ERROR: null
});
